export const FETCH_RESERVATION_LOADING = 'FETCH_RESERVATION_LOADING';
export const FETCH_RESERVATION_SUCCESS = 'FETCH_RESERVATION_SUCCESS';
export const FETCH_RESERVATION_ERROR = 'FETCH_RESERVATION_ERROR';

